
      document.querySelector('portfolio-chat-room').addEventListener("close", () => {
        console.log("close")
      })
    